// @flow
// this type is used to help determine if data coming into the HitchpinCard component
// requires conversion
export const CardInstanceType = {
  Storefront: 'storefront',
  CardDetails: 'cardDetails',
  MyWantedListing: 'myWantedListing',
  StorefrontListing: 'storefrontListing',
  MyOfferingListing: 'myOfferingListing',
  WantedMatch: 'wantedMatch',
  OfferingMatch: 'offeringMatch',
  SimilarListing: 'similarListing',
  SimilarWanted: 'similarWanted',
};
